module.exports = __webpack_public_path__ + "static/media/warm-up.b9890216.vtt";